import {
    booleanAttribute,
    ChangeDetectionStrategy,
    Component,
    Input
} from '@angular/core';
import { ContentBlockComponent } from '../content-block/content-block.component';
import { SanitizeHtmlPipe } from '../../pipes/sanitize-html.pipe';
import { SanitizeUrlPipe } from '../../pipes/sanitize-url.pipe';

@Component({
    selector: 'nw-click-dimensions-block',
    imports: [ContentBlockComponent, SanitizeHtmlPipe, SanitizeUrlPipe],
    templateUrl: './click-dimensions-block.component.html',
    styleUrl: './click-dimensions-block.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ClickDimensionsBlockComponent {
    @Input({ transform: booleanAttribute }) border: boolean = false;

    @Input() title?: string;
    @Input() topcontent?: string;
    @Input() bottomcontent?: string;
    @Input() clickdimensionsurl!: string;
    @Input() height?: number;
}
